import { createSlice } from '@reduxjs/toolkit';
import { addCanvasFrameAndPolygon, deleteCanvasPolygon, getCanvasFrameAndPolygon, updateCanvasPolygon } from './polygon-thunk';
const initialState = {
    canvas: null,
    polygons: null,
    loading: false,
    error: null
};
export const canvasFrameSlice = createSlice({
    name: 'canvasFrame',
    initialState,
    reducers: {
        clearCanvas(state) {
            state.canvas = null;
            state.polygons = null;
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addCanvasFrameAndPolygon.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(addCanvasFrameAndPolygon.fulfilled, (state, action) => {
            state.loading = false;
            state.canvas = action.payload;
        })
            .addCase(addCanvasFrameAndPolygon.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder
            .addCase(getCanvasFrameAndPolygon.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(getCanvasFrameAndPolygon.fulfilled, (state, action) => {
            state.loading = false;
            state.polygons = action.payload;
        })
            .addCase(getCanvasFrameAndPolygon.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder
            .addCase(deleteCanvasPolygon.fulfilled, (state, action) => {
            state.loading = false;
            // state.polygons = state.polygons?.data.filter((polygon) => polygon.id !== action.payload.id) || null;
        })
            .addCase(deleteCanvasPolygon.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
            .addCase(deleteCanvasPolygon.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder
            .addCase(updateCanvasPolygon.pending, (state) => {
            state.loading = true;
        })
            .addCase(updateCanvasPolygon.fulfilled, (state, action) => {
            state.loading = false;
            state.canvas = action.payload;
        })
            .addCase(updateCanvasPolygon.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
});
export const { clearCanvas } = canvasFrameSlice.actions;
export default canvasFrameSlice.reducer;
